<template>
  <div id="app">
    <!-- 修改密码 -->
    <el-dialog
      :visible.sync="visible"
      title="修改密码"
      width="800px"
      :lock-scroll="true"
      :center="true"
    >
      <el-form ref="passform" :model="passform" label-width="120px">
        <el-form-item
          label="原始密码"
          prop="oldPassword"
          :rules="[
            { required: true, message: '密码不能为空', trigger: 'blur' },
            { min: 6, message: '密码必须为6位以上', trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model="passform.oldPassword"
            type="password"
          />
        </el-form-item>
        <el-form-item
          prop="newPassword"
          label="新密码"
          :rules="[
            { required: true, message: '密码不能为空', trigger: 'blur' },
            { min: 6, message: '密码必须为6位以上', trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model="passform.newPassword"
            type="password"
          />
        </el-form-item>
        <el-form-item
          label="确认新密码"
          prop="newPassword1"
          :rules="[
            {
              validator: checkPassword,
              required: true,
              trigger: 'blur',
            },
            { min: 6, message: '密码必须为6位以上', trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model="passform.newPassword1"
            type="password"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelpass">取消</el-button>
        <el-button size="small" type="primary" @click="submitpass"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-popover ref="popover" placement="bottom" width="200" trigger="hover">
      <div class="popovername" v-if="roleTypes == 'teacher' ? true : false">
        <span v-if="roleTypes == 'teacher' ? true : false">
          <el-image
            class="imglogo"
            style="float: left"
            :src="hostUrl + userDatas.headPhotoUrl"
            fit="cover"
          >
            <div slot="error" class="image-slot">
              <i
                ><img
                  style="height: 40px"
                  v-if="userDatas.sex == 1"
                  src="../../assets/img/sex0.png"
              /></i>
              <i
                ><img
                  style="height: 40px"
                  v-if="userDatas.sex == 0"
                  src="../../assets/img/默认头像.png"
              /></i>
              <i
                ><img
                  style="height: 40px"
                  v-if="userDatas.sex == null"
                  src="../../assets/img/默认头像.png"
                  alt=""
                  srcset=""
              /></i></div
          ></el-image>
        </span>
        <div v-if="roleTypes == 'teacher' ? true : false" class="usernames">
          {{ userDatas.name }}
        </div>
      </div>
      <el-divider v-if="roleTypes == 'teacher' ? true : false"></el-divider>
      <ul class="header_right_se">
        <li
          v-for="item in roleByUserData"
          :key="item.id"
          v-if="item.id != '-1006' || item.id != '-1002'"
          v-show="item.id == roleTypeId ? false : true"
          @click="qiehuan(item.id)"
        >
          切换 {{ item.name }}
        </li>
        <!-- <li
          v-if="roleTypes == 'teacher' ? true : false"
          @click="$router.push('/teacherbasic')"
        >
          个人资料
        </li> -->
        <li @click="xgpassword">修改密码</li>
        <li class="unLogin" @click="unLogin">退出登录</li>
      </ul>
    </el-popover>
    <div class="header">
      <img
        v-if="schoolData.schoolLogo"
        :src="schoolUrl + schoolData.schoolLogo"
      />
      <div class="hearder_right">
        <add-bookss
          v-show="roleTypes == 'teacher' ? true : false"
          class="header_btns"
        ></add-bookss>
        <div
          v-show="roleType == 'school' && configStatus"
          class="gongzuos"
          @click="handleOrder"
        >
          <div>订单管理</div>
        </div>
        <div
          v-show="roleTypes == 'teacher' ? true : false"
          class="gongzuos"
          @click="$router.push('/teachernotice')"
        >
          <el-badge :hidden="ftreaded" is-dot style="font-size: 14px"
            >公告</el-badge
          >
        </div>
        <div @click="handleBackBench" class="gongzuo" v-show="isEditInfo">
          工作台
        </div>
        <div class="hearder_right_user" v-popover:popover>
          <!-- <span v-if="roleTypes == 'teacher' ? true : false">
            <el-image
              class="imglogo"
              :src="hostUrl + userDatas.headPhotoUrl"
              fit="cover"
            >
              <div slot="error" class="image-slot">
                <i
                  ><img
                    style="height: 40px"
                    v-if="userDatas.sex == 1"
                    src="../../assets/img/sex0.png"
                    alt=""
                    srcset=""
                /></i>
                <i
                  ><img
                    style="height: 40px"
                    v-if="userDatas.sex == 0"
                    src="../../assets/img/默认头像.png"
                    alt=""
                    srcset=""
                /></i>
                <i
                  ><img
                    style="height: 40px"
                    v-if="userDatas.sex == null"
                    src="../../assets/img/默认头像.png"
                    alt=""
                    srcset=""
                /></i>
                </div
            ></el-image>
          </span> -->
          <div class="username">{{ userDatas.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import addBookss from '../bench/components/addbook'
import {
  usercenterinfo,
  schoolgetinfo,
  getBookList,
  deleteBook,
  getBookSubjectList,
  getVersionList,
  getVolumeList,
  getChaptertreeVo,
  addBook,
  getMyappList,
  UserLogout,
  modifyPassWord,
  roleByUser,
} from '@/api/home'
import { receiveList } from '@/api/notice.js'
export default {
  components: {
    addBookss,
  },
  props: ['configStatus', 'isEditInfo'],
  data() {
    return {
      userData: [],
      userDatas: [],
      schoolData: [],
      visible: false,
      token: '',
      schoolId: 0,
      roleType: localStorage.getItem('roleType'),
      roleTypes: localStorage.getItem('roleTypes'),
      hostUrl: '', //根路径
      passform: {
        oldPassword: '',
        newPassword: '',
        newPassword1: '',
      },
      path: '',
      roleByUserData: [],
      roleTypeId: 0,
      notice: {
        userId: '',
        schoolId: '',
        roleType: '',
      },
      receiveDataList: [],
      ftreaded: true,
      isSchool: '',
      schoolUrl: '',
    }
  },

  created() {
    this.token = this.$route.query.token
    if (this.token == undefined && this.token == '') {
      localStorage.setItem('token', this.token)
      this.usercenterinfo()
      this.path = this.$route.path
    } else {
      // this.token = localStorage.getItem('token')
      this.usercenterinfo()
      this.path = this.$route.path
    }
  },
  methods: {
    //返回工作台
    handleBackBench() {
      this.$emit('backBench')
    },
    // 获取发布给自己的公告
    async receiveList() {
      this.notice.schoolId = localStorage.getItem('schoolIds')
      this.notice.userId = localStorage.getItem('userId')
      this.notice.roleType = localStorage.getItem('roleTypes')

      const { data: res } = await receiveList({
        ...this.notice,
      })
      this.receiveDataList = res.data.dataList
      res.data.dataList.forEach((item) => {
        if (item.readed == false) {
          this.ftreaded = false
        }
      })
    },

    //   获取当前用户登陆信息
    async usercenterinfo() {
      const { data: res } = await usercenterinfo()
      console.log('用户信息--->', res)
      this.userData = res.data
      this.schoolId = res.data.schoolId
      this.isSchool = res.data.roleType
      this.roleType = res.data.roleType
      localStorage.setItem('schoolIds', res.data.schoolId)

      this.hostUrl = res.data.hostUrl
      this.$emit('hostUrl', this.hostUrl)
      this.schoolgetinfo()
      if (res.data.roleType == 'teacher' || this.roleType == 'teacher') {
        this.userDatas = res.data.teacher
        localStorage.setItem('userId', res.data.userId)

        localStorage.setItem('schoolName', res.data.teacher.schoolName)
        if (res.data.roleType == 'teacher' && this.roleType == 'teacher') {
          localStorage.setItem('roleType', res.data.roleType)
          localStorage.setItem('roleTypes', res.data.roleType)
        }

        if (this.token !== undefined && this.token !== '') {
          localStorage.setItem('roleType', res.data.roleType)
          localStorage.setItem('roleTypes', res.data.roleType)
        }

        if (this.userDatas.classesVo) {
          localStorage.setItem('classId', res.data.teacher.classesVo.id)
          localStorage.setItem('gradeId', res.data.teacher.classesVo.gradeId)
        }
        this.roleTypes = localStorage.getItem('roleTypes')
      } else if (res.data.roleType == 'school') {
        this.userDatas = res.data.school
        localStorage.setItem('userId', res.data.school.id)
        localStorage.setItem('roleType', res.data.roleType)
        localStorage.setItem('roleTypes', res.data.roleType)
        localStorage.setItem('schoolName', res.data.school.name)
      } else {
        this.userDatas = res.data.parent
      }
      this.roleByUser()
      this.receiveList()
      console.log(localStorage.getItem('roleTypes'))
    },
    // 获取自己全部角色
    async roleByUser() {
      const roles = localStorage.getItem('roleType')
      if (roles == 'teacher') {
        this.roleTypeId = -1003
      } else if (roles == 'school') {
        this.roleTypeId = -1004
      } else {
        this.roleTypeId = -1002
      }
      localStorage.setItem('roleId', this.roleTypeId)
      this.$emit('roleType', this.roleTypeId)
      const { data: res } = await roleByUser()
      this.roleByUserData = res.data
      console.log(res.data)
    },
    // 获取当前登陆用户的学校信息
    async schoolgetinfo() {
      const { data: res } = await schoolgetinfo({
        id: this.schoolId,
      })
      this.schoolData = res.data
      this.schoolUrl =
        res.data.bucketId == 2
          ? 'https://file.51xiaoping.com/'
          : 'https://cdn.51xiaoping.com/'
    },
    xgpassword() {
      this.visible = true
    },
    // 退出登陆
    async unLogin() {
      const confirResult = await this.$confirm('您确定要退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch((err) => err)
      if (confirResult !== 'confirm') {
        return this.$message.info('已取消！！')
      }
      const res = await UserLogout()
      localStorage.clear()
      sessionStorage.clear()
      this.$router.push('/')
    },

    checkPassword(rule, value, callback) {
      if (!value) {
        return callback(new Error('二次密码不能为空'))
      } else {
        if (this.passform.newPassword !== this.passform.newPassword1) {
          return callback(new Error('两次密码必须输入一致'))
        } else {
          callback()
        }
      }
    },

    cancelpass() {
      this.$refs.passform.resetFields()
      this.visible = false
    },

    submitpass() {
      this.$refs.passform.validate((valid) => {
        if (valid) {
          this.ApiModifyPassByOld()
        } else {
          this.$message.error('请检查信息是否填写正确')
          return false
        }
      })
    },
    async ApiModifyPassByOld() {
      const { passform } = this
      // let {data:res} = await modifyPassWord({ ...passform })
      modifyPassWord({ ...passform }).then((res) => {
        console.log('res:', res)
        if (res.data.code == '0') {
          this.$message.success('修改成功,下次登录请使用新密码登录')
          this.visible = false
          this.resetForm('passform')
        }
      })
    },
    qiehuan(id) {
      this.roleTypeId = id
      if (id == '-1003') {
        localStorage.setItem('roleType', 'teacher')
        this.roleType = 'teacher'
      } else {
        localStorage.setItem('roleType', 'school')
        this.roleType = 'school'
      }
      this.$emit('renew')
      localStorage.setItem('roleId', this.roleTypeId)
      this.$emit('roleType', id)
    },
    //跳转订单详情
    handleOrder() {
      console.log('跳转订单详情')
      this.$emit('orderDetail', 'order')
    },
  },
}
</script>
<style scoped>
.header {
  background-color: #fff;
  height: 60px;
  box-shadow: 0 2px 4px 0 rgba(1, 0, 0, 0.1);
}
.header > img {
  margin-top: 5px;
  margin-left: 30px;
  height: 50px;
}

.hearder_right {
  float: right;
  height: 40px;
  margin-top: 10px;
  margin-right: 30px;
  cursor: pointer;
}
.header_btns {
  float: left;
  margin-top: 9px;
}
.hearder_right_user {
  float: right;
  margin-left: 30px;
}

.imglogo {
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 50%;
}
.username {
  float: right;
  font-size: 14px;
  margin-top: 10px;
  margin-left: 15px;
}
.usernames {
  float: left;
  display: inline-block;
  width: 80px;
  font-size: 14px;
  /* margin-top: 10px; */
  margin-left: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.header_right_se li {
  cursor: pointer;
  list-style: none;
  height: 30px;
  font-size: 14px;
  line-height: 30px;
  margin-bottom: 10px;
  text-align: center;
}
.header_right_se li:hover {
  background-color: #f4f4f4;
}
.header_right_se li:hover {
  background-color: #e1efff;
}
.gongzuo {
  display: inline-block;
  margin-top: 11px;
  font-size: 14px;
  margin-left: 20px;
  cursor: pointer;
}
.gongzuos {
  display: inline-block;
  margin-top: 11px;
  font-size: 14px;
  margin-left: 20px;
  cursor: pointer;
}

.popovername {
  height: 40px;
  line-height: 40px;
  padding: 0 32px;
}
.el-divider {
  margin: 10px 0;
}
.unLogin {
  background-color: #409eff;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/header/header.vue